module.exports = __webpack_public_path__ + "img/BASEPLATE.ffcadaa3.png";